import { render, staticRenderFns } from "./episodeTable.vue?vue&type=template&id=520a7aa6"
import script from "./episodeTable.vue?vue&type=script&lang=js"
export * from "./episodeTable.vue?vue&type=script&lang=js"
import style0 from "./episodeTable.vue?vue&type=style&index=0&id=520a7aa6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports